import { BookContext } from 'common/contexts/Book'
import { LandingContext } from 'common/contexts/Landing/Landing'
import { Button } from 'components/buttons'
import { baseURL } from 'models'
import { CSSProperties, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Container } from './styled'
import { useNavigate } from 'react-router-dom'
import { MenuContext } from 'common/contexts/Menu'

type GeneralMenuProps = {
  hideOurMenu?: boolean
  hideBookTable?: boolean
  hideDelivery?: boolean

  style?: CSSProperties
}

export const GeneralMenu = ({
  hideOurMenu,
  hideBookTable,
  hideDelivery,
  ...props
}: GeneralMenuProps) => {
  const { t } = useTranslation()
  const { setIsOpen } = useContext(BookContext)
  const { setIsOpen: setMenuOpen } = useContext(MenuContext)
  const navigate = useNavigate()
  const { landing } = useContext(LandingContext)
  const lang = localStorage.getItem('Localization') ?? 'uk'
  const isBanquetVisible = landing?._id && landing?.banketEnabled

  const handleOpenMenu = () => {
    if (landing.offlineMenu === null) {
      return
    }
    window.open(`${baseURL}/${landing?.offlineMenu}`, '_blank')
  }

  const onBookTable = () => {
    window.location.href = '/?modal=reservation'
    setIsOpen(true)
  }

  const handleOpenDelivery = () => {
    window.open(
      lang === 'en'
        ? 'https://restaron.ua/en/restaurant/babo-gardens?mode=main'
        : 'https://restaron.ua/restaurant/babo-gardens?mode=main',
      '_blank',
    )
  }
  const onBanquetClick = () => {
    setIsOpen(false)
    setMenuOpen(false)
    navigate('/banquet')
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  return (
    <>
      <Container {...props}>
        {!hideOurMenu && (
          <Button.Text onClick={handleOpenMenu}>{t('our.menu')}</Button.Text>
        )}
        {!hideBookTable && (
          <Button.Text onClick={onBookTable}>{t('book.table')}</Button.Text>
        )}
        {!hideDelivery && (
          <Button.Text onClick={handleOpenDelivery}>
            {t('delivery')}
          </Button.Text>
        )}{' '}
        {isBanquetVisible && (
          <Button.Ellipse width="150px" onClick={onBanquetClick}>
            {t('banquet').toUpperCase()}
          </Button.Ellipse>
        )}
      </Container>
    </>
  )
}
